import { Component, OnInit, Input, ViewChild, OnChanges } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatDialogConfig } from '@angular/material';
import { ViewRequest } from '../shared/view-request.model';
import { ReportsService } from '../shared/reports.service';
import { ConfirmationDialogComponent } from 'src/app/core/modal/confirmation-dialog/confirmation-dialog.component';
import { SaveDescriptionDialogComponent } from 'src/app/core/modal/save-description-dialog/save-description-dialog.component';
import { DeclineAssigment } from '../../assessments/shared/decline-assigment.model';

@Component({
  selector: 'app-view-test-student',
  templateUrl: './view-test-student.component.html',
  styleUrls: ['./view-test-student.component.scss']
})
export class ViewTestStudentComponent implements OnInit, OnChanges {

  displayedColumns: string[] = [ 'solicitud', 'estado', 'prueba', 'fechaSolicitud',
                   'nomMateriaRecon', 'nota',  'semestre', 'operaciones'];
  dataSource: MatTableDataSource<ViewRequest>;
  messageErrorT: String = '';
  claseMessageT: String = 'messaje-error';

  @Input() requests: ViewRequest[];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private dialog: MatDialog,
              private reporstService: ReportsService) {
                this.setTable();
              }

  ngOnInit() {
    this.setTable();
  }

  private setTable() {
    this.dataSource = new MatTableDataSource(this.requests);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ngOnChanges() {
    this.setTable();
  }

  decline(row: ViewRequest) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { tittle: 'Mensaje Confirmación', message: '¿Esta seguro que desea declinar la Solicitud?'};
    dialogConfig.width = '30%';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
        if (value === 1) {
          this.openDialogDecline(row);
        }
    });

  }

  private openDialogDecline (row: ViewRequest) {
    const usuario = localStorage.getItem('cedula');
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { tittle: 'DECLINAR SOLICITUD', filedName: 'Justificación' };
    dialogConfig.width = '40%';
    const dialogRef = this.dialog.open(SaveDescriptionDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if (value !== null) {
          const decline = new DeclineAssigment();
          decline.solicitud = row.codigo;
          decline.consecutivo = row.consecutivo;
          decline.justificacion = value;
           decline.usuario = decodeURIComponent(usuario);
          this.reporstService.declineTests(decline).subscribe(
            (result) => {
              if (result.data) {
                if (result.data === 'OK') {
                  const index = this.requests.indexOf(row);
                  if (index > -1) {
                    this.requests.splice(index, 1);
                    this.setTable();
                 }
                  this.claseMessageT = 'messaje-success';
                  this.messageErrorT = 'Se declino la solicitud #' + row.codigo;
                } else {
                  this.claseMessageT = 'messaje-error';
                  this.messageErrorT = result.data;
                }
              }
            }
          );
      }
    });
  }
}
